import React, { Component } from "react";
import lang from "../../lang/index";
import { Grade, ImageView , Gender, OfficialAuth} from "../../component/user-ui";
import Observer from '../../lib/observer';
import NumberUtil from "../../lib/util/number";

class ListItem extends Component {
    static defaultProps = {
        item: {},
        onClick: function(){},
        showList: ['username','gender', 'grade', 'signature']
    };

    constructor(props) {
        super(props);
    }

    jumpProfile(item) {
        if (item.onlineFlag) {
            hashHistory.push("/living/"+longToString(item.roomUid)+"/"+longToString(item.roomId));
        } else {
            hashHistory.push("/profile/base/"+longToString(item.roomUid));
        }

        this.props.onClick();
    }

    render() {
        let item = this.props.item;
        let  linkTo;
        let diffTime = longToString(item.timeDifference);
        let timeStr;
        let notext = lang.template('ta还没写签名呢，告诉ta?')
        timeStr = NumberUtil.getDiffTime(diffTime);
        if(!item.signature) {
            item.signature = notext;
        }

        return (
            <li data-uid={item.roomUid} key={item.roomUid}>
                <div className="list-item" onClick={() => this.jumpProfile(item)} key={item.roomUid}>
                    <div className="avatar">
                        <Observer>{isVisible => <ImageView src={item.avatar} lazyload={true} size={50} circle isVisible={isVisible} />}</Observer>
                        { item.officialAuth > 0 ? <OfficialAuth value={item.officialAuth}/> : null }
                    </div>
                    <div className="refbox">
                        <div className="user">
                        {
                            this.props.showList.map((key, index)=>{
                                if (key == 'gender') {
                                    return  item.gender ? <Gender key="gender" value={item.gender}/> : null;
                                }

                                if (key == 'grade') {
                                    return item.grade ? <Grade key="grade" value={item.grade}/> : null;
                                }
                                return (
                                    <div key={index} className={key}>{item[key]}</div>
                                );
                            })
                        }


                        </div>
                    </div>
                    <div className="voice-box">
                        { item.onlineFlag ?<div className="live">
                            <i className='live-img'></i>
                            <em></em>
                            </div>: null }
                    </div>
                    <div className='time'>{timeStr}</div>
            </div>
            </li>
        );
    }
}

export default ListItem;



// WEBPACK FOOTER //
// ./js/header/history/host-item.js